import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsRelianceindustrieslimitedComponent } from './simple-icons-relianceindustrieslimited.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsRelianceindustrieslimitedComponent ],
    exports:      [ SimpleIconsRelianceindustrieslimitedComponent ],
    bootstrap:    []
})
export class SimpleIconsRelianceindustrieslimitedModule {}
